import React from 'react';
import Helmet from 'react-helmet';
import config from '../../config';
import { Link } from 'react-router';
import TrackedLink from '../common/TrackedLink';
import TrackedAnchor from '../common/TrackedAnchor';
import { branch } from "baobab-react/higher-order";
import Accessories from '../product/accessories/AccessoriesContainer';

class SecuritySafes extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            Videos: false,
            Accessories: false,
            Register: true
        };
    }

    handleClickVideos() {
        this.setState(prevState => ({
            Videos: !prevState.Videos
        }));
    }

    handleClickAccessories() {
        this.setState(prevState => ({
            Accessories: !prevState.Accessories
        }));
    }

    handleClickRegister() {
        this.setState(prevState => ({
            Register: !prevState.Register
        }));
    }

    render() {

        let name = "Security Safes";
        const product = this.props.product;
        let modelNumber = product.overView.modelNumber;
        let modelNumbers="X055, X125ML";
        const serialNumber = null;
        let pdfManual = product.support[0].description;
        let imageUrl = `${config.contentUrl}/product/sentrysafe/X055_angled.png`;
        let imageUrl2 = `${config.contentUrl}/product/sentrysafe/X125ML_angled.png`;
        let videos = [];
        let registerMySafeLink = `${config.rmsUrlBase}/register`;


        // Function to decode HTML characters
        let decodeHTML = function (html) {
            var txt = document.createElement('textarea');
            txt.innerHTML = html;
            return txt.value;
        };

        // Get all the videos
        try {
            videos = product.aboutMySafeVideos.map(video =>
                <div className="video-container">
                    <div className="embed-responsive-16x9">
                        <iframe
                            width="420" height="315"
                            src={`https://www.youtube.com/embed/${video.youtubeId}`}
                            allowFullScreen
                        />
                    </div>
                    <p>{decodeHTML(video.title)}</p>
                </div>
            );
        } catch (err) {
            console.log('Error getting videos:' + err);
        }


        let accessories = (
            <Accessories accessories={this.props.product.productAccessories}/>
        );

        return (
            <div>
                <Helmet
                    title="Security Safes &#124; SentrySafe"
                    meta={[{
                        property: 'description',
                        content: 'Learn more about your SentrySafe safe by watching the quick start and full instructional videos. You can even download the owner\'s manual.'
                    }]}
                />
                <div className="row about-my-safe mb-4">
                    <div className="safe-info">
                        {!serialNumber &&
                            <p>
                                <a className="arrow-link-left" style={{textTransform: "none"}} href="/about-my-safe/search">Back</a>
                            </p>
                        }

                        <h1>Thank you for purchasing your Security Safe</h1>

                        {imageUrl &&
                            <img src={imageUrl} alt={name}/>
                        }
                        {imageUrl2 &&
                            <img src={imageUrl2} alt={name}/>
                        }


                    </div>
                    <ul className="menu-links">
                        <li className={`${this.state.Register ? 'active' : ''}`}>
                            <TrackedAnchor
                                to={registerMySafeLink}
                                target="_blank"
                                rel="noopener"
                                className="drawer-link trigger"
                            >
                                <div>Register Your Safe</div>

                            </TrackedAnchor>
                            <div className="drawer">
                                <TrackedAnchor
                                    to={registerMySafeLink}
                                    className="about-register-link"
                                    target="_blank"
                                    rel="noopener"
                                >
                                    <p className="p-3 m-0 pr-md-5">Registering your safe and combination means you'll never pay a service charge for a lost or forgotten combination. We can also assist you faster with warranty questions, offer promotions, and provide product updates.</p>
                                    <div className="arrow-link d-block ml-3 pb-4">Register Safe</div>
                                </TrackedAnchor>

                            </div>
                        </li>
                        {videos.length > 0 &&
                            <li className={`${this.state.Videos ? 'active' : ''}`}>
                                <Link
                                    onClick={this.handleClickVideos.bind(this)}
                                    className="drawer-link trigger"
                                >
                                    <div>Video Instructions</div>
                                    <div>
                                        {this.state.Videos
                                            ? <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="minus" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="#e1261c" d="M416 208H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"></path></svg>
                                            : <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="plus" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="#e1261c" d="M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"></path></svg>
                                        }
                                    </div>
                                </Link>
                                <div className="drawer">
                                    {videos}
                                </div>
                            </li>
                        }


                        {modelNumber &&
                            <li className={`${this.state.Accessories ? 'active' : ''}`}>
                                <Link
                                    onClick={this.handleClickAccessories.bind(this)}
                                    className="drawer-link trigger"
                                >
                                    <div>Buy Accessories</div>
                                    <div>
                                        {this.state.Accessories
                                            ? <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="minus" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="#e1261c" d="M416 208H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"></path></svg>
                                            : <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="plus" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="#e1261c" d="M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"></path></svg>
                                        }
                                    </div>
                                </Link>
                                <div className="drawer">
                                    { accessories }
                                </div>
                            </li>
                        }
                        {pdfManual &&
                            <li className="link-download">
                                <TrackedLink
                                    to={`${config.contentUrl}/sentrysafe/resources/pdf/manuals/${pdfManual}`}
                                    target="_blank"
                                    rel="noopener"
                                    className="drawer-link"
                                >
                                    <div>Download Product Manual<span className="ml-3"><svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="download" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="#e1261c" d="M216 0h80c13.3 0 24 10.7 24 24v168h87.7c17.8 0 26.7 21.5 14.1 34.1L269.7 378.3c-7.5 7.5-19.8 7.5-27.3 0L90.1 226.1c-12.6-12.6-3.7-34.1 14.1-34.1H192V24c0-13.3 10.7-24 24-24zm296 376v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h146.7l49 49c20.1 20.1 52.5 20.1 72.6 0l49-49H488c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z"></path></svg>
</span></div>

                                </TrackedLink>
                            </li>
                        }
                        {modelNumber &&
                            <li>
                                <TrackedLink
                                    to={`https://www.sentrysafe.com/product-reviews.htm?bvaction=rr_submit_review&bvproductId=${modelNumber}&bvcampaignId=Customer_Care`}
                                    target="_blank"
                                    rel="noopener"
                                    className="drawer-link"
                                >
                                    Leave A Review
                                </TrackedLink>
                            </li>
                        }
                        <li className="link-download">
                            <TrackedLink
                                to={`https://www.sentrysafe.com/support?bvproductId=${modelNumber}&bvcampaignId=Find_Support`}
                                className="drawer-link"
                                target="_blank"
                                rel="noopener"
                            >
                                Customer Support
                            </TrackedLink>
                        </li>
                    </ul>
                </div>
            </div>
        );
    }
}

export default branch({
    product: ['product']
}, SecuritySafes);


// WEBPACK FOOTER //
// ./src/pages/aboutMySafe/SecuritySafes.js